export const INITIAL_VALUE = {
  mobile: {
    value: "",
    error: "",
  },
  password: {
    value: "",
    error: "",
  },
};

export const ERROR_MESSAGES = {
  mobile: {
    required: "Mobile number is required",
    invalid: "Please enter a valid mobile number",
  },
  password: {
    required: "Password is required",
    invalid: "",
  },
  logIn: {
    default: "Unable to login",
    unknown: "Unknown error occurred",
    google: "Google login failed",
  },
};
